import Button from '@/shared/Button/Button';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useContext } from 'react';

export default function ShortStoryButtons({ activity }) {
  const globalContext = useContext(GlobalContext);

  const file =
    activity.data?.subType == 'pdf'
      ? activity.data.file
      : activity.data.storyPdf;
  const muteFile =
    activity.data?.subType == 'pdf'
      ? activity.data.muteFile
      : activity.data.storyMutePdf;

  const storyPdfAvailable =
    file &&
    ((globalContext.state.user?.teacher &&
      globalContext.state.isSubscriptionActive) ||
      globalContext.state.user?.student ||
      globalContext.state.user?.admin ||
      activity?.free);

  const mutePdfAvailable =
    muteFile &&
    ((globalContext.state.user?.teacher &&
      globalContext.state.isSubscriptionActive) ||
      globalContext.state.user?.student ||
      globalContext.state.user?.admin ||
      activity?.free);

  return !storyPdfAvailable && !mutePdfAvailable ? null : (
    <>
      {storyPdfAvailable ? (
        <Button type="primary" href={file} target="_blank" rel="noreferrer">
          Download Story
        </Button>
      ) : null}
      {mutePdfAvailable ? (
        <Button type="primary" href={muteFile} target="_blank" rel="noreferrer">
          Download Story without texts
        </Button>
      ) : null}
    </>
  );
}
